export const allAuctionType = { value: 'ALL', text: 'All Auctions' };

export const auctionType = {
  pending: {
    value: '6797BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Pending Auctions',
  },
  completed: {
    value: '6897BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Completed Auctions',
  },
  superseded: {
    value: '6A97BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Superseded Auctions',
  },
  canceled: {
    value: '6697BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'Canceled Auctions',
  },
};

export const defaultAuctionTypeValue = auctionType.pending.value;

export const auctionTypesWithAll = [
  allAuctionType,
  ...Object.values(auctionType),
];
export const auctionTypes = Object.values(auctionType);
